export default __webpack_public_path__ + "static/media/left_side_facing_camera.291eaf7a.mp3";